const ACTIVE_STATUSES = new Set(['active', 'trialing', 'valid']);

export const isSubscriptionActive = (subscription) => {
    if (!subscription) return false;
    const status = String(subscription.status ?? subscription.stripe_status ?? '').toLowerCase();
    return ACTIVE_STATUSES.has(status);
};

export const hasActiveSubscriptionFromApi = (data) => isSubscriptionActive(data?.subscription);

export const isActivityFree = (activity) => (
    activity?.isFree === 1 || activity?.isFree === true
);

/**
 * Only the *current* weekly exercise is playable without login.
 * Past weekly exercises follow normal free/premium rules.
 * Other free content needs login; premium needs active/trialing subscription.
 * Staff with canManageActivities can preview without subscribing.
 */
export const canAccessActivityMedia = ({
    isAuthenticated,
    canBypass = false,
    activityIsFree,
    hasActiveSubscription,
    isCurrentWeeklyExercise = false,
}) => {
    if (canBypass) return true;
    // Current weekly exercise only: playable without account
    if (isCurrentWeeklyExercise) return true;
    if (!isAuthenticated) return false;
    if (activityIsFree) return true;
    return Boolean(hasActiveSubscription);
};
